module.exports = __webpack_public_path__ + "img/bcoin-icon.5df4934a.webp";